import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { GeofenceAdjustmentsComponent } from './geofence-adjustments/geofence-adjustments.component';
import { StandardPlacesComponent } from './standard-places/standard-places.component';

export const standardPlacesRoutes: Route[] = [
  { path: '', component: StandardPlacesComponent },
  { path: 'geofence-adjustments', component: GeofenceAdjustmentsComponent },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(standardPlacesRoutes)],
})
export class StandardPlacesModule {}
